(function () {
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // Current wall clock in the store timezone, as plain numbers.
  function nowIn(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hour12: false,
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', weekday: 'short'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month - 1, d: +o.day, h: +o.hour % 24, min: +o.minute };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth(), d: n.getDate(), h: n.getHours(), min: n.getMinutes() };
    }
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) n--;
    }
    return d;
  }

  function nextBusinessDay(date) {
    var d = new Date(date.getTime());
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  }

  function fmt(d) { return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function sameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }

  function relative(d, today) {
    if (sameDay(d, today)) return 'Today';
    var t = new Date(today.getTime()); t.setDate(t.getDate() + 1);
    if (sameDay(d, t)) return 'Tomorrow, ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
    return fmt(d);
  }

  function render(el) {
    var tz = el.getAttribute('data-tz') || 'America/Los_Angeles';
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
    var processing = parseInt(el.getAttribute('data-processing'), 10) || 0;
    var tMin = parseInt(el.getAttribute('data-transit-min'), 10) || 2;
    var tMax = parseInt(el.getAttribute('data-transit-max'), 10) || 4;

    var n = nowIn(tz);
    var today = new Date(n.y, n.m, n.d, 12, 0, 0);
    var beforeCutoff = n.h < cutoff;

    // Orders after the cutoff count as placed on the next business day.
    var base = beforeCutoff ? today : (function () { var t = new Date(today.getTime()); t.setDate(t.getDate() + 1); return t; })();
    base = nextBusinessDay(base);
    var ship = processing > 0 ? addBusinessDays(base, processing) : base;
    if (sameDay(ship, today) && !beforeCutoff) ship = addBusinessDays(today, 1);
    var arriveMin = addBusinessDays(ship, tMin);
    var arriveMax = addBusinessDays(ship, tMax);

    var head = el.querySelector('[data-fr-delivery-head]');
    var orderEl = el.querySelector('[data-fr-delivery-order]');
    var shipEl = el.querySelector('[data-fr-delivery-ship]');
    var arriveEl = el.querySelector('[data-fr-delivery-arrive]');

    if (orderEl) orderEl.textContent = 'Today, ' + MONTHS[today.getMonth()] + ' ' + today.getDate();
    if (shipEl) shipEl.textContent = relative(ship, today);
    if (arriveEl) {
      arriveEl.textContent = sameDay(arriveMin, arriveMax)
        ? fmt(arriveMin)
        : (fmt(arriveMin) + ' to ' + fmt(arriveMax));
    }

    if (head) {
      var tpl = head.getAttribute('data-tpl');
      if (!tpl) { tpl = head.textContent; head.setAttribute('data-tpl', tpl); }
      if (beforeCutoff && tpl.indexOf('{time}') !== -1) {
        var minsLeft = (cutoff * 60) - (n.h * 60 + n.min);
        var hrs = Math.floor(minsLeft / 60), mins = minsLeft % 60;
        var t = hrs > 0 ? (hrs + 'h ' + mins + 'm') : (mins + 'm');
        head.textContent = tpl.replace('{time}', t);
      } else {
        var after = el.getAttribute('data-heading-after') || 'Order today, ships {ship_day}';
        head.textContent = after.replace('{ship_day}', relative(ship, today).toLowerCase());
      }
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fr-delivery]').forEach(render);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Refresh the countdown once a minute.
  setInterval(function () { init(); }, 60000);
})();
